import Vue from 'vue'
import appConfig from '@/config.js'
import { polyline } from 'leaflet'
import { JsonProvider } from 'leaflet-geosearch'

class GeoFencesProvider extends JsonProvider {
  search({ query, type }) {
    const params = {
      limit: 25,
      includes: [
        'geo_type'
      ],
      filter_groups: [
        {
          or: true,
          filters: [
            ['external_id', 'ct', query],
            ['name', 'ct', query]
          ]
        }
      ]
    }
    return Vue.http.get(appConfig.api.baseUrl + 'geo-fences', { params })
      .then(response => {
        return this.parse(response.body.data)
      })
  }

  parse(data) {
    return data.map((x) => ({
      x: x.lng,
      y: x.lat,
      label: x.external_id,
      visibleLabel: x.external_id + ' - ' + x.name,
      bounds: this.getBounds(x.geo_type.type, x)
    }))
  }

  getBounds(type, x) {
    let element
    let coordinates
    if (x.fence) {
      coordinates = x.fence.coordinates
    } else {
      coordinates = x.path ? x.path.coordinates : [x.lat, x.lng]
    }
    // For map
    const cleanupDupes = x.fence?.coordinates ? [Array.from(new Set(coordinates[0].map(a => a.join('|'))), s => s.split('|').map(Number))] : null
    coordinates = cleanupDupes
      ? cleanupDupes.map(x =>
        x.map(([lng, lat]) => ({ lat, lng }))
      )
      : coordinates

    if (type !== 'point') {
      element = polyline(coordinates)
      return [
        element.getBounds().getSouthWest(),
        element.getBounds().getNorthEast()
      ]
    } else {
      return coordinates
    }
  }
}

export default GeoFencesProvider
